<div class="perfil">
  <!-- Niveles por encima de la luminaria y cuál manda -->
  <app-jerarquia-luminaria
    [idLuminaria]="luminaria?._id"
  ></app-jerarquia-luminaria>

  <!-- Aplicación del perfil: comandos enviados, reintentos, éxito o fallo.
       La comparación config real vs. deseada se abre en un modal. -->
  <app-cronologia-perfil
    [luminaria]="luminaria"
    [configDeseada]="configDeseada"
  ></app-cronologia-perfil>

  <!-- Comandos manuales (encender, apagar, modo, reset) con el nivel desde el
       que se originaron -->
  <app-cronologia-comandos [luminaria]="luminaria"></app-cronologia-comandos>

  <!-- Métricas de downlinks (histórico persistido) -->
  <app-detalle-metricas-downlinks
    [deveui]="luminaria?.dispositivo?.deveui"
  ></app-detalle-metricas-downlinks>
</div>
